<!-- 全局页脚组件 -->
<template>
  <footer class="site-footer">
    <div class="container">
      <div class="footer-top">
        <div class="footer-brand">
          <div class="logo-text">
            <span class="logo-brand">科曼驰</span>
            <span class="logo-en">KOMANCH</span>
          </div>
          <p>高端无痕修复 · 原厂漆守护者</p>
        </div>
        <div class="footer-links">
          <div class="footer-column">
            <h4>服务项目</h4>
            <ul>
              <li><router-link to="/product">凹陷修复</router-link></li>
              <li><router-link to="/product">玻璃修复</router-link></li>
              <li><router-link to="/product">局部点漆</router-link></li>
            </ul>
          </div>
          <div class="footer-column">
            <h4>关于我们</h4>
            <ul>
              <li><router-link to="/about">公司简介</router-link></li>
              <li><router-link to="/news">新闻资讯</router-link></li>
              <li><router-link to="/contact">联系我们</router-link></li>
            </ul>
          </div>
          <div class="footer-column">
            <h4>工作时间</h4>
            <ul>
              <li>周一至周日</li>
              <li>9:00 - 18:30</li>
              <li>上门服务需提前预约</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <p>Copyright © 2025 北京科曼驰汽车服务有限公司 KOMANCH 版权所有</p>
        <p>京ICP备2025123456号</p>
        <p class="footer-links-inline">
          <router-link to="/order-submit">提交订单</router-link>
          <span class="sep">·</span>
          <a :href="adminUrl" target="_blank">管理登录</a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue'

const adminUrl = computed(() => {
  // 生产环境使用当前域名，开发环境使用 localhost
  const hostname = window.location.hostname
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://127.0.0.1:8081/admin/#/login'
  }
  // 生产环境：使用当前域名和协议
  return `${window.location.protocol}//${hostname}/admin/#/login`
})
</script>

<style scoped lang="scss">
$gold: #d4af37;
$gray: #999;

.site-footer {
  padding: 60px 0 32px;
  background: #111;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.footer-top {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 60px;
  padding-bottom: 40px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.footer-brand {
  .logo-text {
    display: flex;
    align-items: baseline;
    gap: 4px;

    .logo-brand {
      font-size: 22px;
      font-weight: 700;
      color: #fff;
      letter-spacing: 2px;
    }

    .logo-en {
      font-size: 12px;
      font-weight: 400;
      color: $gray;
      letter-spacing: 3px;
      margin-left: 8px;
    }
  }

  p {
    font-size: 14px;
    color: $gray;
    margin-top: 8px;
  }
}

.footer-links {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;

  .footer-column {
    h4 {
      font-size: 14px;
      font-weight: 600;
      color: #fff;
      margin-bottom: 16px;
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        font-size: 14px;
        color: $gray;
        line-height: 2;

        a {
          color: $gray;
          text-decoration: none;
          transition: color 0.3s ease;

          &:hover {
            color: $gold;
          }
        }
      }
    }
  }
}

.footer-bottom {
  padding-top: 24px;
  text-align: center;

  p {
    font-size: 13px;
    color: $gray;
    margin: 4px 0;
  }

  .footer-links-inline {
    font-size: 12px;
    color: $gray;
    a {
      color: $gray;
      text-decoration: none;
      transition: color 0.3s;
      &:hover { color: $gold; }
    }
    .sep { margin: 0 6px; color: #444; }
  }
}

@media (max-width: 1024px) {
  .footer-top {
    grid-template-columns: 1fr;
    gap: 40px;
  }
}

@media (max-width: 768px) {
  .footer-links {
    grid-template-columns: 1fr;
    gap: 24px;
  }
}
</style>
